var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.featured.length > 0)?_c('EmergingArtists',{attrs:{"cards":_vm.featured,"title":"Featured","cardsPerRow":3}}):_vm._e(),_c('EmergingArtists',{attrs:{"cards":_vm.emerging,"title":"Artists","cardsPerRow":4}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }